const PUBLIC_DEMO_SOURCE = "publicDemo"
const PUBLIC_DEMO_SURFACE = "publicDemoPage"
const PUBLIC_DEMO_ENTRY_KEY = "qwPublicDemoEntry"
const PUBLIC_DEMO_CURRENT_KEY = "qwPublicDemoCurrent"
const PUBLIC_DEMO_PREVIOUS_KEY = "qwPublicDemoPrevious"

const PublicToolDemoAnalyticsEvent = Object.freeze({
	VIEWED: "public_tool_demo_viewed",
	CTA_CLICKED: "public_tool_demo_cta_clicked",
	INTEREST_SUBMITTED: "public_tool_demo_interest_submitted",
	WAITLIST_JOINED: "public_tool_demo_waitlist_joined",
	WAITLIST_FAILED: "public_tool_demo_waitlist_failed",
	RUNTIME_LOADED: "public_tool_demo_runtime_loaded",
	TAB_CHANGED: "public_tool_demo_tab_changed",
	SAVE_CLICKED: "public_tool_demo_save_clicked",
	SAVE_COMPLETED: "public_tool_demo_save_completed",
	SAVE_FAILED: "public_tool_demo_save_failed",
	SIGNUP_STARTED: "public_tool_demo_signup_started",
	ACCOUNT_CREATED: "public_tool_demo_account_created",
})

function getWindowLocation() {
	return typeof window !== "undefined" ? window.location : null
}

function getSessionStorage() {
	return typeof window !== "undefined" ? window.sessionStorage : null
}

function getDocumentReferrer() {
	return typeof document !== "undefined" ? document.referrer : ""
}

function readJsonSessionValue(key) {
	let result = null
	try {
		result = JSON.parse(getSessionStorage()?.getItem(key) || "null")
	} catch (error) {
		result = null
	}
	return result
}

function writeJsonSessionValue(key, value) {
	try {
		getSessionStorage()?.setItem(key, JSON.stringify(value || null))
	} catch (error) {
		// Analytics context should never block the page.
	}
}

function getUtmProperties() {
	let location = getWindowLocation()
	let params = new URLSearchParams(location?.search || "")
	return {
		utmSource: params.get("utm_source") || "",
		utmMedium: params.get("utm_medium") || "",
		utmCampaign: params.get("utm_campaign") || "",
		utmTerm: params.get("utm_term") || "",
		utmContent: params.get("utm_content") || "",
	}
}

function getPageIdentity(pageDefinition = {}) {
	return {
		toolType: pageDefinition.toolType || "",
		slug: pageDefinition.slug || "",
		toolTitle: pageDefinition.h1 || pageDefinition.title || "",
	}
}

function updatePublicDemoSequence(pageDefinition = {}) {
	let currentPage = getPageIdentity(pageDefinition)
	let entryPage = readJsonSessionValue(PUBLIC_DEMO_ENTRY_KEY)
	let currentStoredPage = readJsonSessionValue(PUBLIC_DEMO_CURRENT_KEY)
	let previousPage = readJsonSessionValue(PUBLIC_DEMO_PREVIOUS_KEY)
	if (!entryPage?.toolType) {
		entryPage = currentPage
		writeJsonSessionValue(PUBLIC_DEMO_ENTRY_KEY, entryPage)
	}
	if (currentStoredPage?.slug !== currentPage.slug) {
		if (currentStoredPage?.slug) {
			previousPage = currentStoredPage
			writeJsonSessionValue(PUBLIC_DEMO_PREVIOUS_KEY, previousPage)
		}
		writeJsonSessionValue(PUBLIC_DEMO_CURRENT_KEY, currentPage)
	}

	return {
		entryToolType: entryPage?.toolType || "",
		entrySlug: entryPage?.slug || "",
		previousToolType: previousPage?.toolType || "",
		previousSlug: previousPage?.slug || "",
	}
}

function getAnalyticsSessionId(analyticsManager) {
	let result = ""
	if (typeof analyticsManager?.getAmplitudeSessionId === "function") {
		result = analyticsManager.getAmplitudeSessionId() || ""
	}
	return result
}

function buildPublicToolDemoAnalyticsProps({
	pageDefinition,
	analyticsManager = null,
	isStaticPlaceholder = false,
	isImplementedTool = false,
	extraProps = {},
}) {
	let location = getWindowLocation()
	return {
		...getPageIdentity(pageDefinition),
		source: PUBLIC_DEMO_SOURCE,
		surface: PUBLIC_DEMO_SURFACE,
		isStaticPlaceholder: !!isStaticPlaceholder,
		isImplementedTool: !!isImplementedTool,
		path: `${location?.pathname || ""}${location?.search || ""}`,
		referrer: getDocumentReferrer(),
		sessionId: getAnalyticsSessionId(analyticsManager),
		eventTimestamp: Date.now(),
		...getUtmProperties(),
		...updatePublicDemoSequence(pageDefinition),
		...extraProps,
	}
}

function trackPublicToolDemoEvent(analyticsManager, eventName, props) {
	if (analyticsManager?.trackEvent) {
		analyticsManager.trackEvent(eventName, props)
	}
}

exports.PublicToolDemoAnalyticsEvent = PublicToolDemoAnalyticsEvent
exports.buildPublicToolDemoAnalyticsProps = buildPublicToolDemoAnalyticsProps
exports.trackPublicToolDemoEvent = trackPublicToolDemoEvent
